import {useCallback, useEffect, useState} from 'react';
import {Object3D} from 'three';
import {FSMStore, outlineStore} from 'webgl/stores';
import {isValidTypes} from 'webgl/hooks/useActiveObject';

export const useHandleGotoState = (object: Object3D): () => void => {
  const [gotoState, setGotoState] = useState<string | null>(null);
  const setFSMState = FSMStore(state => state.setFSMState);
  const stateExists = FSMStore(state => state.stateExists);

  useEffect(() => {
    const {tags} = object.userData;
    if (isValidTypes(tags?.type, 'gotoState') && stateExists(tags?.gotoState)) {
      setGotoState(tags.gotoState);
    }
  }, [object, stateExists]);

  const handleGotoState = useCallback(() => {
    if (gotoState) setFSMState(gotoState);
  }, [gotoState, setFSMState]);

  return handleGotoState;
};